import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { EditionDocumentationListStore } from "../../store/EditionDocumentationListStore";

type EditionDocumentationListDialogsProps = {
  store: EditionDocumentationListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de EditionDocumentation.
 * Separado para mantener EditionDocumentationListPage más limpio.
 */
export const EditionDocumentationListDialogs: React.FC<EditionDocumentationListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
